import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./productRange.module.scss";
import { getProductsFilterByRange } from "../../../services/filterService";
import { getDealFilterByRange } from "../../../services/filterDealService";

const ProductRangeContainer = (props) => {
	const heading = props.heading ? props.heading : "Explore our product range";

	let newCategoryList = props?.categoryList;
	const getSortOrder = (position) => {
		return function (a, b) {
			if (a[position] > b[position]) {
				return 1;
			} else if (a[position] < b[position]) {
				return -1;
			}
			return 0;
		};
	};
	newCategoryList?.sort(getSortOrder("position"));

	const defaultSelectedValue = props?.selectedFilter?.selectedProductRange
		? props.selectedFilter.selectedProductRange
		: props?.selectedFilter?.selectedCategory
		? props?.selectedFilter?.selectedCategory
		: null;
	let [selectedProductID, setSelectedProduct] = useState(
		props.emptyCategories ? null : defaultSelectedValue
	);

	const filterByRange = async (selectedProductID) => {
		if (props.page) {
			switch (props.page) {
				case "deal-grid":
					return getDealFilterByRange(selectedProductID);
				case "buy-bundle":
					props.setBundleData(selectedProductID ? selectedProductID : "All");
					break;
			}
		} else {
			return getProductsFilterByRange(selectedProductID);
		}
	};
	const handleProductSelect = (productID) => {
		if (selectedProductID != productID) {
			setSelectedProduct((selectedProductID = productID));
		} else {
			setSelectedProduct((selectedProductID = null));
		}
		filterByRange(selectedProductID);
		props.handleSelected(productID);
	};
	useEffect(() => {
		if (props?.selectedFilter?.selectedProductRange) {
			setSelectedProduct(Number(props?.selectedFilter?.selectedProductRange));
		} else if (props?.selectedFilter?.selectedCategory) {
			setSelectedProduct(Number(props?.selectedFilter?.selectedCategory));
		} else if (props.emptyCategories) {
			setSelectedProduct(null);
		} else {
			setSelectedProduct(null);
		}
	}, [
		props?.selectedFilter?.selectedProductRange ||
			props?.selectedFilter?.selectedCategory,
	]);
	return (
		<div
			className={`${
				props.hide ? styles.hide : styles["product-range-container"]
			} ${props.customClassName}`}
		>
			<span
				className={styles["product-section-title"]}
				id="product_range_header"
			>
				{heading}
			</span>
			<div
				className={`${styles["product-card-container"]} ${props.customcardClassName}`}
			>
				{props?.categoryList?.map((product) => (
					<div
						key={product.id}
						id={product.id}
						onClick={() => {
							handleProductSelect(product.id);
						}}
						className={`${styles["product-range-card"]} ${
							Number(product.id) === Number(selectedProductID)
								? styles["product-range-card-selected"]
								: ""
						}`}
					>
						<span className={styles["product-card-body-icon"]}>
							{!selectedProductID ||
							Number(product.id) !== Number(selectedProductID) ? (
								<img
									className={styles.image}
									src={product.imageUrl}
									alt="Category"
								/>
							) : (
								<img
									className={styles.image}
									src={product.imageUrl}
									alt="Category"
								/>
							)}
						</span>
						<div className={`${styles["product-card-label"]} 
						${product.name!= "Phones & SIM" ?  styles["productlabel-card-styling"]: ""} `}>
							<span
								id={product.name}
								className={`${
									Number(product.id) === Number(selectedProductID)
										? styles["product-card-label-selected"]
										: ""
								}`}
							>
								{product.name}
							</span>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

ProductRangeContainer.propTypes = {
	handleContainer: PropTypes.func,
	categoryList: PropTypes.array,
	hide: PropTypes.bool,
	handleSelected: PropTypes.func,
	heading: PropTypes.string,
	selectedFilter: PropTypes.any,
	customClassName: PropTypes.string,
	customcardClassName: PropTypes.string,
	emptyCategories: PropTypes.any,
	page: PropTypes.string,
	setBundleData: PropTypes.func,
};
export default ProductRangeContainer;
